import React from "react";
import { NavLink, Link } from "react-router-dom";

const Navigation = () => {
  return (
    <>
      <header className="container">
        <h3>
          <Link className="logo" to="/">
            Speecher
          </Link>
        </h3>
        <nav>
          <ul>
            <li>
              <NavLink to="/" exact>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/manage">Manage</NavLink>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Navigation;
